import _MemoryRouter from './MemoryRouter';
export { _MemoryRouter as MemoryRouter };
import _Prompt from './Prompt';
export { _Prompt as Prompt };
import _Redirect from './Redirect';
export { _Redirect as Redirect };
import _Route from './Route';
export { _Route as Route };
import _Router from './Router';
export { _Router as Router };
import _StaticRouter from './StaticRouter';
export { _StaticRouter as StaticRouter };
import _Switch from './Switch';
export { _Switch as Switch };
import _matchPath from './matchPath';
export { _matchPath as matchPath };
import _withRouter from './withRouter';
export { _withRouter as withRouter };


//////////////////
// WEBPACK FOOTER
// /Users/niko/Work/sketch/antd-pro/ant-design-pro-site/scaffold/node_modules/_react-router@4.2.0@react-router/es/index.js
// module id = 1022
// module chunks = 0